export default __webpack_public_path__ + "static/media/SZYBKOSC.0a1f97d1.png";